import {Button, FormGroup, Intent} from "@blueprintjs/core";
import {observer} from "mobx-react";
import React from "react";

import {ValidatedInputText} from "../../molecules/validated-input-text/validated-input-text";
import {TagAddStore} from "./tag-add-store";

export const TagAddForm: React.FC<{
    store: TagAddStore;
    onCreated?: () => Promise<unknown>;
}> = observer(({store, onCreated}) => {
    return (
        <>
            <FormGroup label="ラベル">
                <ValidatedInputText
                    labelForId="tag-add-label-input"
                    ariaLabel="タグラベル"
                    dataTestId="tag-add-label-input"
                    value={store.label}
                    validationResult={store.labelValidationResult}
                    validationInProgress={store.isLabelChecking}
                    onChangeValue={(s) => {
                        store.setLabel(s);
                    }}
                    helperText={store.isLabelConflicted ? "すでに利用されています" : undefined}
                    helperIntent={store.isLabelConflicted ? Intent.DANGER : Intent.NONE}
                />
            </FormGroup>

            <FormGroup label="スラッグ">
                <ValidatedInputText
                    labelForId="tag-add-slug-input"
                    ariaLabel="タグスラッグ"
                    dataTestId="tag-add-slug-input"
                    value={store.slug}
                    validationResult={store.slugValidationResult}
                    validationInProgress={store.isSlugChecking}
                    onChangeValue={(s) => {
                        store.setSlug(s);
                    }}
                    helperText={store.isSlugConflicted ? "すでに利用されています" : undefined}
                    helperIntent={store.isSlugConflicted ? Intent.DANGER : Intent.NONE}
                />
            </FormGroup>

            <Button
                disabled={!store.canCreate}
                onClick={() =>
                    store.create(() => {
                        if (onCreated) onCreated();
                    })
                }
            >
                追加
            </Button>
        </>
    );
});
